"use client";

function formatBody(body) {
  if (!body) return null;
  const lines = body.split("\n").filter(Boolean);

  return (
    <div className="space-y-4 mt-5">
      {lines.map((line, i) => {
        // Numbered items: "1. text" or "1 text"
        const numMatch = line.match(/^(\d+)[.\s、)]\s*(.+)/);
        if (numMatch) {
          return (
            <div key={i} className="flex gap-5 items-baseline">
              <span
                className="text-xs font-medium flex-shrink-0"
                // a11y fix: removed opacity 0.4 (would have caused ~2:1 contrast
                // on dark themes). textSecondary already meets WCAG AA.
                style={{
                  color: "var(--color-textSecondary)",
                  minWidth: "20px",
                }}
              >
                {numMatch[1].padStart(2, "0")}
              </span>
              <p
                className="text-sm leading-7"
                style={{ color: "var(--color-textSecondary)" }}
              >
                {numMatch[2]}
              </p>
            </div>
          );
        }

        return (
          <p
            key={i}
            className="text-sm leading-7"
            style={{ color: "var(--color-textSecondary)" }}
          >
            {line}
          </p>
        );
      })}
    </div>
  );
}

export default function ContentCards({ title, subtitle, items = [] }) {
  if (!items.length) return null;

  return (
    <section style={{ padding: "0 var(--spacing-pagePadding) 48px" }}>
      <div className="max-w-lg mx-auto">
        <div className="space-y-0">
          {items.map((item, idx) => (
            <article
              key={item.id}
              className="accent-left-border stagger-fade-in"
              style={{
                padding: "32px 0 32px 16px",
                borderBottom:
                  idx < items.length - 1
                    ? "1px solid var(--color-cardBorder)"
                    : "none",
                "--stagger-delay": `${idx * 0.08}s`,
              }}
            >
              <div className="flex items-baseline gap-4 mb-1">
                <span
                  className="text-xs tracking-widest flex-shrink-0"
                  // a11y fix (axe: color-contrast):
                  // 0.65 opacity gave 4.34:1 (still below 4.5), drop opacity
                  // and use textSecondary which already meets AA on all themes
                  style={{ color: "var(--color-textSecondary)" }}
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <h2
                  className="text-sm md:text-base font-bold tracking-wide"
                  // a11y fix (axe: heading-order): page has h1 from PageHeader,
                  // so section item titles should be h2 (was h3 → jump)
                  style={{
                    fontFamily: "var(--font-heading)",
                    color: "var(--color-text)",
                  }}
                >
                  {item.title}
                </h2>
              </div>

              <div className="pl-10">{formatBody(item.body)}</div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
